import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/TiendaOficial`

export function buscarTodas(buscar) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${buscar}`)
}

export function buscarTienda(idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarTienda/${idUsuario}`)
}

export function buscarTodos(buscar) {
  return http.get(`${API_ENDPOINT}/BuscarTiendaPlan/${buscar}`)
}

export function buscarPeriodicidadCobro(buscar) {
  return http.get(`${API_ENDPOINT}/BuscarPeriodicidadCobro/${buscar}`)
}

export function actualizarTienda(tiendaOficial) {
  return http.put(API_ENDPOINT, tiendaOficial)
}

export function insertarTienda(tiendaOficial) {
  return http.post(API_ENDPOINT, tiendaOficial)
}

export function subirArchivo(tiendaOficial) {
  return http.post(`${API_ENDPOINT}/Upload`, tiendaOficial)
}

export function buscarAdjuntos(idTiendaOficial, esBanner) {
  return http.get(`${API_ENDPOINT}/BuscarAdjuntos/${idTiendaOficial}/${esBanner}`)
}
